<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-1">
<h1>Chapter 1</h1>
<p>Did she just say what I thought she said? Did I hear it right?</p>
<p>I shook my head in disbelief. How could she have thought that, let alone voiced what was inside her head?</p>
<p>She was asking for trouble and I didn’t want to be a part of it. Not only would it stir up strife within the friendship group but it would have far reaching consequences. I shuddered and didn’t want to contemplate what fate might bring.</p>
<p>Crystal, Sophie and myself had been friends since primary school and it seemed only natural we continue our friendship in a co-ed private secondary college.</p>
<p>We found ourselves little fish in a big sea and we had to learn to swim, each of us trying to reinvent ourselves and deal with the challenges of growing up.</p>
<p>Two’s company, three’s a crowd wasn’t working as well so we welcomed in Ashleigh Jackson, who’d moved interstate for her father’s business.</p>
<p>We were an unlikely group of friends.</p>
<p>Ashleigh was oblivious to her classic cliché natural beauty. Tall, slim, everything in its right place. Long voluminous hair, green eyes, flawless skin. Didn’t matter what she wore, everything fitted perfectly, even the school uniform. She was slightly blonde but not dumb. Her parents were professionals but were never there for her.</p>
<p>Crystal was the outrageous but loveable one, always up for a dare and pushed the boundaries. She experimented with hair dye and reinvented the uniform code much to the teachers’ dismay. Crystal came from a single parent house after her dad died last year. She worked part-time in the local supermarket to help pay the bills and keep the family afloat.</p>
<p>Sophie we knew was gay but she hadn’t officially come out. While the rest of us were growing breasts, she remained flat-chested and wore her hair short. She was dealing with the blended family thing after her mum remarried.</p>
<p>Me, I considered myself average looking; going through the ugly duckling stage, dealing with pesky pimples, bad hair days and an expanding body. My frizzy hair was the bane of my existence and always looked like I’d had an electric shock. I was in the minority with a relatively normal family by today’s standards.</p>
<p>Maybe because we were all trying to make sense of life but somehow, the 4 of us seemed to click.</p>
<p>It was good to have close friends as support and Crystal came up with the catch phrase, ‘love you, love me’ as a form of BFF unanimity.</p>
<p>I also had a non-identical twin sister, Holly. We were like chalk and cheese, both in appearance <em>and</em> in personality. She scored the looks; I gained the brains. She was funny, outgoing and sporty and could charm her way into anything.</p>
<p>I was the opposite. Although completely useless at sport, I excelled at school. I considered myself an observer, quiet, super sensitive and preferred to be invisible.</p>
<p>Like most teenagers, despite our differences and the occasional clash with our parents, as twins, we generally tolerated each other.</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?2810b072